import "./dialog.scss"
import Select from 'react-select'
import { Link, useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Dialog } from "@material-ui/core";
import { useEffect, useState } from "react";
import axios from "axios";
import httpService from "../../../../setup/http/httpServices";


interface ScreenDetailProps {
    open: boolean;
    onClose: () => void;
    elements?: any[];
    screenCategory?: any[];
    associatedTags?: any[];
    screenId?: string;
    deleteHandler?: () => void;

}


const ScreenDetailDialog = ({ open, onClose, elements, screenCategory, associatedTags, screenId, deleteHandler }: ScreenDetailProps) => {

    const history: any = useHistory()
    const baseURL = process.env.REACT_APP_API_URL;
    const [screenDetails, setScreenDetails] = useState<any>([]);

    const [categoryOption, setCategoryOption] = useState<any[]>([]);
    const [elementOption, setElementOption] = useState<any[]>([]);
    const [associatedTag, setAssociatedTag] = useState<any[]>([]);


    const selectedCategoryOption: string[] = categoryOption?.map((item: any) => item.value);
    const selectedElementOption: string[] = elementOption?.map((item: any) => item.value);
    const selectedTagOption: string[] = associatedTag?.map((item: any) => item.value);


    console.log('categoryOption', categoryOption)
    console.log('associatedTag', associatedTag)
    console.log('screen detail edit', history.location.state?.edit)

    console.log('screenDetails', screenDetails)


    useEffect(() => {
        setCategoryOption(screenDetails?.screen_categories);
        setElementOption(screenDetails?.ui_element_categories);
        setAssociatedTag(screenDetails?.Tags);
        console.log('hello', screenDetails)
        console.log('screenDetails Tags', screenDetails?.Tags)
    }, [])


    const handleCategoryChange = (selectedOption: any) => {
        setCategoryOption(selectedOption);
        console.log('selectedOption', selectedOption)
    };

    const handleElementChange = (selectedOption: any) => {
        setElementOption(selectedOption);
    };

    const handleTagsChange = (selectedOption: any) => {
        setAssociatedTag(selectedOption);
    };

    // useEffect(() => {
    //     if (screenId) {
    //         httpService.getData(
    //             `/app-screen/${screenId}`,
    //             (res) => {
    //                 setScreenDetails(res.data?.screenDetails);
    //             },
    //             (err) => {
    //                 console.log('Error fetching screen details:', err);
    //             }
    //         );
    //     }
    // }, [screenId]);

    useEffect(() => {
        if (screenId) {
            httpService.getData(
                `/app-screen/${screenId}`,
                (res) => {
                    setScreenDetails(res.data?.screenDetails);
                    const { screen_categories, ui_element_categories, Tags } = res.data?.screenDetails;
                    setCategoryOption(screen_categories?.map(category => ({ value: category.id, label: category.Name })));
                    setElementOption(ui_element_categories?.map(category => ({ value: category.id, label: category.Name })));
                    setAssociatedTag(Tags?.map(tag => ({ value: tag.id, label: tag.Name })));
                },
                (err) => {
                    console.log('Error fetching screen details:', err);
                }
            );
        }
    }, [screenId]);




    // screen detail
    const fetchScreenDetails = () => {
        if (history.location.state?.edit) {
            axios.patch(
                `${baseURL}/app-screen/update/${screenId}`,
                {
                    headers: httpService.serviceHeader,
                    screen_categories: selectedCategoryOption,
                    ui_element_categories: selectedElementOption,
                    tag_ids: selectedTagOption,

                }
            ).then((res) => {
                console.log('Screen Updated details:', res.data);
                onClose();
            }).catch((error) => {
                console.error('Error:', error);
            });
        } else {
            axios.post(
                `${baseURL}/app-screen/add/${screenId}`,
                {
                    headers: httpService.serviceHeader,
                    screen_categories: selectedCategoryOption,
                    ui_element_categories: selectedElementOption,
                    tag_ids: selectedTagOption,

                }
            ).then((res) => {
                console.log('Screen details:', res.data);
                onClose();
            }).catch((error) => {
                console.error('Error:', error);
            });
        }

    };





    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="xl" className="screen-detail-dialog">
                <div className="screen-details">
                    <div className="screen-header">
                        <h1>Screen Details</h1>
                        <div className="close-icon" onClick={onClose}>
                            <img
                                style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                alt='icon'
                            />
                        </div>
                    </div>
                    <div className="detail-box">
                        <div className="img-box">
                            <img src={screenDetails?.image} alt="img" />
                        </div>
                        <div className="info-box">
                            <div className="row">
                                <div className='col '>
                                    <h6 className='fw-bold required'>Screen Category</h6>
                                    <Select
                                        options={screenCategory?.map(category => ({ value: category._id, label: category.Name }))}
                                        placeholder="Search and Select"
                                        className="text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-1 categorySelect "
                                        styles={{
                                            menuList: (provided, state) => ({
                                                ...provided,
                                                height: 'auto',
                                                maxHeight: '200px',
                                            }),
                                        }}
                                        value={categoryOption}
                                        onChange={handleCategoryChange}
                                        isSearchable // This enables search functionality
                                        isMulti
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className='col '>
                                    <h6 className='fw-bold'>Associated UI Elements</h6>
                                    <Select
                                        options={elements?.map((item: any) => ({ value: item._id, label: item.Name }))}
                                        placeholder="Search and Select"
                                        className="text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-1 categorySelect"
                                        styles={{
                                            menuList: (provided, state) => ({
                                                ...provided,
                                                height: 'auto',
                                                maxHeight: '200px',
                                            }),
                                        }}
                                        value={elementOption}
                                        onChange={handleElementChange}
                                        isSearchable
                                        isMulti
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className='col '>
                                    <h6 className='fw-bold'>Associated Tags</h6>
                                    <Select
                                        options={associatedTags?.map(item => ({ value: item._id, label: item.Name }))}
                                        placeholder="Search and Select"
                                        className="text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-1 categorySelect"
                                        styles={{
                                            menuList: (provided, state) => ({
                                                ...provided,
                                                height: 'auto',
                                                maxHeight: '200px',
                                            }),
                                        }}
                                        value={associatedTag}
                                        onChange={handleTagsChange}
                                        isSearchable
                                        isMulti
                                    />
                                </div>
                            </div>
                            <div className='d-flex pt-4 pe-5'>
                                <button
                                    type='submit'
                                    id='kt_sign_up_submit'
                                    className='btn btn-primary  CompanyDetailButton'
                                    onClick={() => fetchScreenDetails()}
                                >
                                    <span className='indicator-label'>Save Changes</span>

                                </button>

                                <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton' onClick={onClose}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </Dialog>
        </>
    )
}

export default ScreenDetailDialog